import { ConfigManager } from "@/application/config/Config";
import { LoggerFactory } from "@/application/logging/Logger";
import { CreateCheckoutSessionRequest ,CreateCheckoutSessionResponse, CheckoutSessionResponse, CancelSubscriptionRequest, SaveSubscriptionRequest } from "@/types";

export class StripeRepository {
  private readonly config = ConfigManager.getInstance().getApiConfig();
  private readonly logger = LoggerFactory.getLogger();

  private get jsonHeaders(): HeadersInit {
    return {
      accept: "*/*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
    };
  }

  async createCheckoutSession(
    payload: CreateCheckoutSessionRequest
  ): Promise<CreateCheckoutSessionResponse | null> {
    const url = `${this.config.baseUrl}/stripe/create_checkout_session`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: this.jsonHeaders,
        body: JSON.stringify(payload),
      });

      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      this.logger.error("createCheckoutSession failed", error as Error, { ...payload });
      return null;
    }
  }

  async getCheckoutSession(sessionId: string): Promise<CheckoutSessionResponse | null> {
    const url = `${this.config.baseUrl}/stripe/checkout_session?session_id=${encodeURIComponent(sessionId)}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      });

      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      this.logger.error("getCheckoutSession failed", error as Error, { sessionId });
      return null;
    }
  }

  async cancelSubscription(payload: CancelSubscriptionRequest): Promise<boolean> {
    const url = `${this.config.baseUrl}/stripe/cancel_subscription`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: this.jsonHeaders,
        body: JSON.stringify(payload),
      });

      return response.ok;
    } catch (error) {
      this.logger.error("cancelSubscription failed", error as Error, { ...payload });
      return false;
    }
  }

  async saveSubscription(payload: SaveSubscriptionRequest): Promise<boolean> {
    const url = `${this.config.baseUrl}/stripe/save_subscription`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: this.jsonHeaders,
        body: JSON.stringify(payload),
      });

      return response.ok;
    } catch (error) {
      this.logger.error("saveSubscription failed", error as Error, { ...payload });
      return false;
    }
  }

  async getCurrentSubscription(userId: string): Promise<any | null> {
    const url = `${this.config.baseUrl}/stripe/current_subscription?user_id=${encodeURIComponent(userId)}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      });

      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      this.logger.error("getCurrentSubscription failed", error as Error, { userId });
      return null;
    }
  }
}
